import {
  MEDICALERT,
  MEDICALERT_CA,
  MEDICALERT_UK,
  PROFILE_INFO,
} from '../actions/fetchEmergencySession';

/**
 * This function checks for multiple variations of the MedicAlert permission.
 * Returns true if the given permissions includes MedicAlert, false otherwise.
 * @param {Array.<string>} permissions
 */
const hasMedicAlertAccess = (permissions = []) => {
  if (!Array.isArray(permissions)) {
    return false;
  }
  const normalized = permissions.map((str = '') => {
    let s = str;
    if (typeof s !== 'string') {
      s = `${s}`;
    }
    return s.toLowerCase();
  });

  return (
    normalized.includes(PROFILE_INFO) ||
    normalized.includes(MEDICALERT) ||
    normalized.includes(MEDICALERT_CA) ||
    normalized.includes(MEDICALERT_UK)
  );
};

export default hasMedicAlertAccess;
